import { render } from "./SectionArtists.vue?vue&type=template&id=35159ea6&scoped=true"
import script from "./SectionArtists.vue?vue&type=script&lang=js"
export * from "./SectionArtists.vue?vue&type=script&lang=js"

import "./SectionArtists.vue?vue&type=style&index=0&id=35159ea6&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35159ea6"]])

export default __exports__